import addToCartPmd from '../PmdCartCookie/addToCart';
var addToCart = function addToCart(cart, settings) {
  addToCartPmd(cart, settings, {
    prefix: 'parceiro'
  });
};
export default addToCart;